import {
  Music,
  Trophy,
  Drama,
  Laugh,
  PartyPopper,
  Gamepad2,
  Building2,
  Palette,
} from "lucide-react";

/** Matches new-ui CreateEvent.tsx category picker (8 categories). */
export const CREATE_EVENT_CATEGORIES = [
  { id: "concerts", label: "Concerts", icon: Music, color: "#E52324", legacyIds: ["music"] },
  { id: "sports", label: "Sports", icon: Trophy, color: "#3B82F6" },
  { id: "theater", label: "Theater", icon: Drama, color: "#A855F7", legacyIds: ["arts-theater"] },
  { id: "comedy", label: "Comedy", icon: Laugh, color: "#F59E0B" },
  { id: "festivals", label: "Festivals", icon: PartyPopper, color: "#EC4899" },
  { id: "gaming", label: "Gaming", icon: Gamepad2, color: "#06B6D4" },
  { id: "conference", label: "Conference", icon: Building2, color: "#10B981" },
  { id: "art", label: "Art & Culture", icon: Palette, color: "#F97316", legacyIds: ["other"] },
];

export function findCreateEventCategory(categoryId) {
  if (!categoryId) return undefined;
  return CREATE_EVENT_CATEGORIES.find(
    (cat) => cat.id === categoryId || cat.legacyIds?.includes(categoryId)
  );
}

export function normalizeCreateEventCategoryId(categoryId) {
  return findCreateEventCategory(categoryId)?.id ?? categoryId;
}
